import axios from "axios";
import store from "../redux/store/store";

const API_OUTWARD_URL = import.meta.env.VITE_OUTWARD_URL;

// Çekirdek AI eşleştirme ucu (backend: Areas/IA/Controller/AiMatchController.cs).
// Kategori/Marka/Varyant/Varyant Değeri eşleştirmelerinin hepsi bu tek ucu, sadece
// farklı candidatesJson ile kullanır.
const iaService = {
  match: async (ourValue, candidatesJson, token) => {
    try {
      const userToken = token ?? store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_OUTWARD_URL}/IA/AiMatch`,
        { ourValue, candidatesJson },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.error("AI eşleştirme isteğinde hata oluştu:", error);
      throw error;
    }
  },
};

export default iaService;
